
import { Component } from "@angular/core";
import { CommonModule } from '@angular/common';
import { EmailValidator, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';


@Component({
  standalone: true,
  imports: [ CommonModule,ReactiveFormsModule ],
  selector: 'app-kb-home-category',
  templateUrl: './home-kb.component.html',
  styleUrl: './home-kb.component.scss'
})




export class KBHomeComponent {
  public searchForm: FormGroup;
  items: any[] = [];

  constructor(private fb: FormBuilder, private router: Router, private http: HttpClient) {
    this.searchForm = this.fb.group({
      searchtext: ["", Validators.required],
      domain: ["", Validators.required],
    });
    this.load();
  }

    load(){
  
      this.http.get<any>(`${environment.apiUrl}/kb/menus` ).subscribe(
        (response) => {
          this.items = response;
          console.log(response);
        },
        (error) => {
          console.error('Error:', error);
        });
    }
  

  send() {
    const params = { q: this.searchForm.value["searchtext"] };
      this.router.navigate(['/kb/search'], { queryParams: params });
  }

}

